import React from 'react';
import numeral from 'numeral';
import InstallmentItemSC, { RedAlertSC } from './installment-item.styled';
import { SmallText, BodyText } from '../../../typography';
import Mark from '../../../ui/mark';
import dlt from '../../../../utils/default-lang';
import { FormattedMessage } from 'react-intl';

const InstallmentItem = ({ date, amount, status, isTablet }) => {
  return (
    <InstallmentItemSC>
      <td>
        <BodyText className={status === 'not-paid' ? 'bolder red' : 'bolder'}>
          {date}
          {status === 'not-paid' ? <RedAlertSC>!</RedAlertSC> : null}
        </BodyText>
        {isTablet ? (
          <BodyText className={status === 'not-paid' ? 'red' : ''}>
            {numeral(Number(amount)).format('0,00.00')} €
          </BodyText>
        ) : null}
      </td>
      {isTablet ? null : (
        <td>
          <BodyText className={status === 'not-paid' ? 'red' : ''}>
            {numeral(Number(amount)).format('0,00.00')} €
          </BodyText>
        </td>
      )}

      <td>
        <SmallText className="bolder">
          <Mark
            colorStyle={
              status === 'pending'
                ? ''
                : status === 'partially'
                ? 'ORANGE'
                : status === 'paid'
                ? 'GREEN'
                : 'RED'
            }
          >
            {status === 'pending' ? (
              <FormattedMessage
                id="global_pending_to_pay"
                defaultMessage={dlt['global_pending_to_pay']}
              />
            ) : status === 'partially' ? (
              <FormattedMessage
                id="global_partially_paid"
                defaultMessage={dlt['global_partially_paid']}
              />
            ) : status === 'paid' ? (
              <FormattedMessage id="global_paid" defaultMessage={dlt['global_paid']} />
            ) : (
              <FormattedMessage id="global_not_paid" defaultMessage={dlt['global_not_paid']} />
            )}
          </Mark>
        </SmallText>
      </td>
    </InstallmentItemSC>
  );
};

export default InstallmentItem;
